<section aria-label="Personalnachweise" *ngIf="model" class="nachweise">
  <h3>Personalnachweise</h3>
  <p>Die Nachweise gelten trägerweit für diesen Mitarbeiter. Personalbogen und weitere Unterlagen können nachgereicht werden.</p>
  <div *ngIf="!readOnly" class="uploadbereich">
    <div class="uploadzeile">
      <div class="artauswahl">
        <span class="feldlabel">Dokumentart</span>
        <dx-select-box [items]="arten" valueExpr="id" displayExpr="name" [(value)]="uploadArt" [showClearButton]="false"
          [inputAttr]="{'aria-label': 'Dokumentart für neue Nachweise'}" [disabled]="disabled || !arten.length"></dx-select-box>
      </div>
      <dx-file-uploader selectButtonText="Nachweise auswählen" labelText="" [multiple]="true" uploadMode="useForm"
        [showFileList]="false" [allowedFileExtensions]="['.pdf', '.jpg', '.jpeg']" accept="application/pdf,image/jpeg"
        [maxFileSize]="104857600" [disabled]="disabled || !arten.length" [value]="pickerFiles" (onValueChanged)="selectFiles($event.value)"></dx-file-uploader>
    </div>
    <p class="dateihinweis">PDF oder JPEG, höchstens 100 MiB je Datei</p>
  </div>
  <p *ngIf="artenFehler" class="text-danger" role="alert">Dokumentarten konnten nicht geladen werden.
    <dx-button text="Erneut laden" stylingMode="text" (onClick)="loadArten()"></dx-button>
  </p>
  <div class="filterzeile">
    <dx-text-box #suche placeholder="Dateinamen suchen" [inputAttr]="{'aria-label': 'Dateinamen suchen'}" [showClearButton]="true"
      valueChangeEvent="input" [value]="search" (onValueChanged)="search = $event.value; updateDocuments()"></dx-text-box>
    <dx-select-box [items]="arten" valueExpr="id" displayExpr="name" placeholder="Alle Dokumentarten"
      [inputAttr]="{'aria-label': 'Nach Dokumentart filtern'}" [showClearButton]="true" [value]="filterArt" (onValueChanged)="filterArt = $event.value; updateDocuments()"></dx-select-box>
  </div>
  <dx-data-grid [dataSource]="documents" keyExpr="key" [showBorders]="true" [showRowLines]="true" [showColumnLines]="false"
    [wordWrapEnabled]="true" [hoverStateEnabled]="true" (onContentReady)="onContentReady()"
    [noDataText]="search || filterArt ? 'Keine Nachweise für diese Auswahl.' : 'Noch keine Personalnachweise hinterlegt.'">
    <dxo-paging [enabled]="false"></dxo-paging>
    <dxo-grouping [autoExpandAll]="true" expandMode="rowClick"></dxo-grouping>
    <dxo-sorting mode="none"></dxo-sorting>
    <dxi-column dataField="gruppe" [groupIndex]="0" groupCellTemplate="gruppe" sortOrder="asc"></dxi-column>
    <dxi-column dataField="name" caption="Datei" cellTemplate="datei" [minWidth]="100"></dxi-column>
    <dxi-column caption="Dokumentart" cellTemplate="art" [width]="235" [visible]="!narrow"></dxi-column>
    <dxi-column dataField="created" caption="Hinterlegt am" cellTemplate="datum" [width]="105" [visible]="!narrow"></dxi-column>
    <dxi-column caption="Aktionen" cellTemplate="aktionen" alignment="right" [width]="readOnly ? 78 : 112"></dxi-column>
    <div *dxTemplate="let group of 'gruppe'" class="gruppenname">
      {{groupName(group.value)}} <span>· {{groupCount(group.value)}} {{groupCount(group.value) === 1 ? 'Datei' : 'Dateien'}}</span>
    </div>
    <div *dxTemplate="let row of 'datei'" class="dateizelle">
      <span class="dateiname">{{row.data.name}}</span>
      <span *ngIf="row.data.upload" class="neue-datei">Neu – noch nicht gespeichert</span>
      <span *ngIf="row.data.upload && !validFile(row.data.upload.file)" class="text-danger">Bitte eine PDF- oder JPEG-Datei mit 1 Byte bis 100 MiB auswählen.</span>
      <div *ngIf="narrow" class="datei-details">
        <ng-container *ngTemplateOutlet="artEditor; context: {$implicit: row.data}"></ng-container>
        <span>{{row.data.created ? ('Hinterlegt am ' + (row.data.created | date:'dd.MM.yyyy')) : 'Wird beim Speichern hinterlegt'}}</span>
      </div>
    </div>
    <div *dxTemplate="let row of 'art'"><ng-container *ngTemplateOutlet="artEditor; context: {$implicit: row.data}"></ng-container></div>
    <div *dxTemplate="let row of 'datum'">{{row.data.created ? (row.data.created | date:'dd.MM.yyyy') : 'Beim Speichern'}}</div>
    <div *dxTemplate="let row of 'aktionen'" class="aktionen">
      <dx-button icon="download" hint="Herunterladen" [elementAttr]="{'aria-label': row.data.name + ' herunterladen'}" (onClick)="download(row.data)"></dx-button>
      <dx-button icon="eyeopen" hint="Vorschau" [elementAttr]="{'aria-label': row.data.name + ' – Vorschau'}"
        [disabled]="!!row.data.upload && !validFile(row.data.upload.file)" (onClick)="openPreview(row.data)"></dx-button>
      <dx-button *ngIf="!readOnly" icon="trash" hint="Beim Speichern entfernen" [elementAttr]="{'aria-label': row.data.name + ' beim Speichern entfernen'}"
        [disabled]="disabled" (onClick)="remove(row.data)"></dx-button>
    </div>
  </dx-data-grid>
  <ng-template #artEditor let-row>
    <span *ngIf="readOnly">{{artName(row.dokumentart)}}</span>
    <dx-select-box *ngIf="!readOnly" [items]="arten" valueExpr="id" displayExpr="name" [value]="row.dokumentart" [showClearButton]="false"
      [inputAttr]="{'aria-label': 'Dokumentart für ' + row.name}" [disabled]="disabled || !arten.length" (onValueChanged)="changeArt(row, $event)"></dx-select-box>
  </ng-template>
  <p *ngIf="removedCount" class="entfernungen">
    {{removedCount}} {{removedCount === 1 ? 'Nachweis wird' : 'Nachweise werden'}} beim Speichern entfernt.
    <dx-button text="Entfernen rückgängig machen" stylingMode="text" [disabled]="disabled" (onClick)="undoRemove()"></dx-button>
  </p>
  <span class="sr-only" role="status" aria-live="polite">{{status}}</span>
</section>
<dx-popup title="Dokumentenvorschau" width="90vw" height="85vh" [showCloseButton]="true" [dragEnabled]="false"
  [(visible)]="previewVisible" (onHidden)="closePreview()">
  <div *dxTemplate="let data of 'content'" class="nachweis-vorschau">
    <ng-container *ngIf="preview">
      <cz-document-viewer *ngIf="preview.dokument" [fileName]="preview.dokument.fileName"></cz-document-viewer>
      <cz-document-viewer *ngIf="preview.upload && preview.name.toLowerCase().endsWith('.pdf')" [pdfUrl]="previewUrl"></cz-document-viewer>
      <img *ngIf="preview.upload && !preview.name.toLowerCase().endsWith('.pdf')" [src]="previewUrl" [alt]="preview.name">
    </ng-container>
  </div>
</dx-popup>
